import { StatefulEmitter } from '@apia/util';

class IsEnabledEmitter extends StatefulEmitter<{
  isEnabled: boolean;
}> {}

export const isAssistantEnabled = new IsEnabledEmitter({ isEnabled: false });

export function useIsAssistantEnabled() {
  return {
    isEnabled: isAssistantEnabled.useState('isEnabled'),
    setIsEnabled: (newIsEnabled: boolean) => {
      isAssistantEnabled.emit('isEnabled', newIsEnabled);
    },
  };
}
